// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../rescript/lib/es6/caml_option.js";
import * as Utils$PorterinFusionkitSentryReact from "../../fusionkit-sentry-react/src/Utils.bs.js";

function init_options(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9, prim10, prim11, prim12, prim13, prim14, prim15, prim16, prim17, prim18, prim19, prim20, prim21, prim22, prim23, prim24, prim25, prim26, prim27) {
  var tmp = {
    dsn: prim0,
    environment: prim3
  };
  if (prim1 !== undefined) {
    tmp.debug = Caml_option.valFromOption(prim1);
  }
  if (prim2 !== undefined) {
    tmp.release = Caml_option.valFromOption(prim2);
  }
  if (prim4 !== undefined) {
    tmp.tunnel = Caml_option.valFromOption(prim4);
  }
  if (prim5 !== undefined) {
    tmp.dist = Caml_option.valFromOption(prim5);
  }
  if (prim6 !== undefined) {
    tmp.sampleRate = Caml_option.valFromOption(prim6);
  }
  if (prim7 !== undefined) {
    tmp.maxBreadcrumbs = Caml_option.valFromOption(prim7);
  }
  if (prim8 !== undefined) {
    tmp.attachStackTrace = Caml_option.valFromOption(prim8);
  }
  if (prim9 !== undefined) {
    tmp.ignoreErrors = Caml_option.valFromOption(prim9);
  }
  if (prim10 !== undefined) {
    tmp.ignoreTransactions = Caml_option.valFromOption(prim10);
  }
  if (prim11 !== undefined) {
    tmp.denyUrls = Caml_option.valFromOption(prim11);
  }
  if (prim12 !== undefined) {
    tmp.allowUrls = Caml_option.valFromOption(prim12);
  }
  if (prim13 !== undefined) {
    tmp.autoSessionTracking = Caml_option.valFromOption(prim13);
  }
  if (prim14 !== undefined) {
    tmp.maxValueLength = Caml_option.valFromOption(prim14);
  }
  if (prim15 !== undefined) {
    tmp.normalizeDepth = Caml_option.valFromOption(prim15);
  }
  if (prim16 !== undefined) {
    tmp.normalizeMaxBreadth = Caml_option.valFromOption(prim16);
  }
  if (prim17 !== undefined) {
    tmp.enabled = Caml_option.valFromOption(prim17);
  }
  if (prim18 !== undefined) {
    tmp.sendClientReports = Caml_option.valFromOption(prim18);
  }
  if (prim19 !== undefined) {
    tmp.integrations = Caml_option.valFromOption(prim19);
  }
  if (prim20 !== undefined) {
    tmp.defaultIntegrations = Caml_option.valFromOption(prim20);
  }
  if (prim21 !== undefined) {
    tmp.enableTracing = Caml_option.valFromOption(prim21);
  }
  if (prim22 !== undefined) {
    tmp.tracesSampleRate = Caml_option.valFromOption(prim22);
  }
  if (prim23 !== undefined) {
    tmp.tracePropagationTargets = Caml_option.valFromOption(prim23);
  }
  if (prim24 !== undefined) {
    tmp.profileSampleRate = Caml_option.valFromOption(prim24);
  }
  if (prim25 !== undefined) {
    tmp.replaysSessionSampleRate = Caml_option.valFromOption(prim25);
  }
  if (prim26 !== undefined) {
    tmp.replaysOnErrorSampleRate = Caml_option.valFromOption(prim26);
  }
  return tmp;
}

var React = {
  init_options: init_options,
  initSentry: Utils$PorterinFusionkitSentryReact.initSentry,
  init: Utils$PorterinFusionkitSentryReact.init,
  setTag: Utils$PorterinFusionkitSentryReact.setTag,
  setUser: Utils$PorterinFusionkitSentryReact.setUser,
  captureException: Utils$PorterinFusionkitSentryReact.captureException,
  captureMessage: Utils$PorterinFusionkitSentryReact.captureMessage,
  captureExceptionWithContext: Utils$PorterinFusionkitSentryReact.captureExceptionWithContext,
  captureMessageWithContext: Utils$PorterinFusionkitSentryReact.captureMessageWithContext,
  capturePromiseError: Utils$PorterinFusionkitSentryReact.capturePromiseError,
  capturePromiseErrorWithContext: Utils$PorterinFusionkitSentryReact.capturePromiseErrorWithContext,
  withProfiler: Utils$PorterinFusionkitSentryReact.withProfiler
};

export {
  React ,
  
}
/* Utils-PorterinFusionkitSentryReact Not a pure module */
